<template>
<div>
  <el-drawer
    :visible.sync="SNDrawerShow"
    class="myDrawer"
    @closed="closedMyDrawer"
    :show-close="false"
  >
    <template v-if="!drawerOption.type">
      <template slot="title">
        <span class="name" v-if="deviceLifeData.workStationVo"
          >SN：{{ drawerOption.currentSNName }}【{{
            deviceLifeData.workStationVo.name
          }}】</span
        >
        <span class="name" v-else
          >SN：{{ drawerOption.currentSNName }}</span
        >
        <el-button size="small" class="ifFocus"></el-button>
        <!-- <el-tooltip effect="dark" content="导出周期" placement="top">
          <i class="el-icon-download myIcon" @click="downLifeBtn($event)"></i>
        </el-tooltip> -->
        <el-tooltip effect="dark" content="导出图片" placement="top">
          <img
            class="myIcon"
            src="../assets/图片.svg"
            alt=""
            @click="downLifeBtn($event, '图片')"
          />
        </el-tooltip>
        <el-tooltip v-if="this.exportXls" effect="dark" content="导出Excel" placement="top">
          <img
            class="myIcon"
            src="../assets/Excel.svg"
            alt=""
            @click="downLifeBtn($event, 'Excel')"
          />
        </el-tooltip>
      </template>
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in deviceLifeData.lifeLine"
          :key="index"
          :timestamp="
            activity.requestDateTime + ' ' + 
            (activity.user ? (activity.user.name + '(' + activity.user.employeeNum + ')') : '')
          "
        >
          <template slot="dot">
            {{ index + 1 }}
          </template>
          <p v-if="activity.workStation" class="allowSkip" @click="workStationBtn(activity)">
            {{ activity.workStation.name }}
          </p>
          <p>
            <span>Key：</span>
            <span>{{ activity.key }}</span>
          </p>
          <p>
            <span>结果：</span>
            <span :class="activity.returnCode != 0 ? 'danger' : 'success'"
              >【{{ activity.returnCode }}】{{ activity.returnMsg? activity.returnMsg :'执行成功'}}</span
            >
          </p>
        </el-timeline-item>
        <p class="noData" v-if="deviceLifeData.lifeLine.length == 0">
          暂无数据
        </p>
      </el-timeline>
    </template>
    <template v-else>
      <template slot="title">
        <span class="name"
          >版本【{{ drawerOption.version }}】，Build【{{
            deviceLifeData.build
          }}】</span
        >
          <el-tooltip effect="dark" style="color:#72767b;" content="删除" placement="top">
            <i @click="deleteFw(deviceLifeData)" class="el-icon-delete allowSkip"></i>
          </el-tooltip>
      </template>
      <div class="versonBox">
        <p>
          <span>类型：</span>
          <span v-if="deviceLifeData.type">{{ deviceLifeData.type.title }}</span>
          <span v-else>-</span>
        </p>
        <p>
          <span>产品：</span>
          <span v-if="deviceLifeData.product">{{ deviceLifeData.product.name }}</span>
          <span v-else>-</span>
        </p>
        <p>
          <span>发布者：</span>
          <span>{{ deviceLifeData.publisher }}</span>
        </p>
        <p>
          <span>发布日期：</span>
          <span>{{ deviceLifeData.publishDate }}</span>
        </p>
        <p>
          <span>定制客户：</span>
          <span v-if="deviceLifeData.customer">{{ deviceLifeData.customer.name }}</span>
          <span v-else>-</span>
        </p>
        <p>
          <span>物料编码：</span>
          <span v-if="deviceLifeData.itemCode">{{ deviceLifeData.itemCode }}</span>
          <span v-else>-</span>
          <i class="el-icon-edit allowSkip"
            @click="updateCodeItem(deviceLifeData)"></i>
        </p>
        <p>
          <span>位置号：</span>
          <span v-if="deviceLifeData.position">{{ deviceLifeData.position }}</span>
          <span v-else>-</span>
          <i class="el-icon-edit allowSkip"
            @click="updatePosition(deviceLifeData)"></i>
        </p>
        <p>
          <span>状态：</span>
          <span v-if="deviceLifeData.status" style="flex:none;">【{{ deviceLifeData.status.title }}】</span>
          <span v-if="deviceLifeData.status && deviceLifeData.status.code=='RC'" class="allowSkip" style="margin-right:10px;" @click="releaseFw(deviceLifeData)">发布</span>
          <span v-if="deviceLifeData.status && (deviceLifeData.status.code=='RC' || deviceLifeData.status.code=='Release')" class="allowSkip" @click="disableFw(deviceLifeData)">禁用</span>
          <span v-if="deviceLifeData.status && deviceLifeData.status.code=='Deprecated'" class="allowSkip" @click="rollbackFw(deviceLifeData)">还原</span>
          <span v-if="!deviceLifeData.status">-</span>
        </p>
        <p v-if="deviceLifeData.status && deviceLifeData.status.code=='Deprecated'">
          <span>禁用者：</span>
          <span v-if="deviceLifeData.disabledUser">{{ deviceLifeData.disabledUser.name}} ({{ deviceLifeData.disabledUser.employeeNum}})</span>
          <span v-else>-</span>
        </p>
        <p>
          <span>发行包：</span>
          <span v-if="deviceLifeData.image" class="textOverflow allowSkip" @click="downloadFile(deviceLifeData.image.fid)" :title="deviceLifeData.image.fileName">{{ deviceLifeData.image.fileName }}</span>
          <span v-else>-</span>
        </p>
        <p>
          <span>MD5：</span>
          <span v-if="deviceLifeData.imageMd5">{{ deviceLifeData.imageMd5 }}</span>
          <span v-else>-</span>
        </p>
        <p v-if="deviceLifeData.upgrade">
          <span>升级包：</span>
          <span v-if="deviceLifeData.upgrade" class="textOverflow allowSkip" @click="downloadFile(deviceLifeData.upgrade.fid)" :title="deviceLifeData.upgrade.fileName">{{ deviceLifeData.upgrade.fileName }}</span>
        </p>
        <p v-if="deviceLifeData.upgradeMd5">
          <span>MD5：</span>
          <span>{{ deviceLifeData.upgradeMd5 }}</span>
        </p>
        <p v-if="deviceLifeData.issue">
          <span>问题清单：</span>
          <span v-if="deviceLifeData.issue" class="textOverflow allowSkip" @click="downloadFile(deviceLifeData.issue.fid)" :title="deviceLifeData.issue.fileName">{{ deviceLifeData.issue.fileName }}</span>
        </p>
        <p>
          <span>版本配置：</span>
          <el-input
            v-if="deviceLifeData.config"
            class="detailTextArea"
            type="textarea"
            :readonly="true"
            :autosize="{minRows: 1, maxRows:8}"
            resize="none"
            :value="deviceLifeData.config"
          ></el-input>
          <span v-else>-</span>
          <i class="el-icon-edit allowSkip" v-if="deviceLifeData.status && deviceLifeData.status.code=='RC'"
            @click="updateConfig(deviceLifeData)"></i>
        </p>
        <p>
          <span>配置文件：</span>
          <el-input
            v-if="deviceLifeData.hardwareConfig"
            class="detailTextArea"
            type="textarea"
            :readonly="true"
            :autosize="{minRows: 1, maxRows:8}"
            resize="none"
            :value="deviceLifeData.hardwareConfig"
          ></el-input>
          <span v-else>-</span>
          <i class="el-icon-edit allowSkip" v-if="deviceLifeData.status && deviceLifeData.status.code=='RC'"
            @click="uploadHardwareConfig(deviceLifeData)"></i>
          <input ref="hardwareConfigInput" type="file" accept=".json" style="display:none;" @change="hardwareConfigFileChange($event)"/>
        </p>
        <p>
          <span>版本日志：</span>
          <el-input
            v-if="deviceLifeData.releaseNotes"
            class="detailTextArea"
            type="textarea"
            :readonly="true"
            :autosize="{minRows: 1, maxRows:8}"
            resize="none"
            :value="deviceLifeData.releaseNotes"
          ></el-input>
          <span v-else>-</span>
          <i class="el-icon-edit allowSkip" v-if="deviceLifeData.status && deviceLifeData.status.code=='RC'"
            @click="updateReleaseNotes(deviceLifeData)"></i>
        </p>
      </div>
    </template>
  </el-drawer>
  <myDialog
      ref="myDialog"
      :title="dialogTitle"      
      @rollBack="rollBack"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="670px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
          class="scrollForm"
        >
        <el-form-item :label="this.dialogTitle=='修改版本日志' ? '版本日志' : '配置信息'" prop="config" size="small">
            <el-input
              type="textarea"
              :autosize="{minRows: 10}"
              placeholder="请输入产品配置信息"
              v-model="dialogForm.config"
            ></el-input>
        </el-form-item>
        </el-form>
      </template>
  </myDialog>
</div>
</template>

<script>
import myDialog from "@/components/myDialog.vue";
import { apiPcbaLife, apiPcbaSnLife } from "@/api/SmtOrder.js";
import { apiDeviceLife } from "@/api/cartonOrder.js";
import { apiFirmwareDetail } from "@/api/firmwareManage.js";
import { apiFirmwareRelease } from "@/api/firmwareManage.js";
import { apiFirmwareDisable } from "@/api/firmwareManage.js";
import { apiFirmwareRollback } from "@/api/firmwareManage.js";
import { apiFirmwareDelete } from "@/api/firmwareManage.js";
import { apiFirmwareUpdateConfig,apiFirmwareUpdateReleaseNotes,apiFirmwareUpdatePosition,apiFirmwareUpdateItemCode } from "@/api/firmwareManage.js";
import { apiFirmwareRollbackConfig } from "@/api/firmwareManage.js";
import { apiFirmwareUpdateHardwareConfig } from "@/api/firmwareManage.js";
import { apiDownloadFile, apiUploadFile } from "@/api/filesUpload.js";

export default {
  components: {
    myDialog
  },
  props: {
    drawerOption: {
      type: null,
    }
  },
  data() {
    return {
      // src: require(""),
      SNDrawerShow: false,
      exportXls: true,
      deviceLifeData: {
        lifeLine: [],
        workStationVo: {},
      },
      dialogTitle: "",
      dialogForm: {
        
      },
      dialogRules: {
        config: [
          { required: true, message: "配置信息不能为空！", trigger: "change" }
        ]
      },
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    // 回滚配置信息
    rollBack() {
      const h = this.$createElement;
      this.$msgbox({
        title: `提示`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入版本号:【`
          ),
          h("i", { style: "color: #F56C6C;white-space:pre !important;" }, this.deviceLifeData.version),
          h("span", null, `】以确认恢复版本配置信息`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == this.deviceLifeData.version) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiFirmwareRollbackConfig({
          id : this.deviceLifeData.id
        });
        if (res.code == 0) {
          this.$refs.myDialog.dialogVisible = false;
          this.getVersion();
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    // 编辑配置
    async updateConfig() {
      this.dialogTitle = "修改版本配置";
      this.$refs.myDialog.dialogVisible = true;
      this.$set(this.dialogForm, "config", this.deviceLifeData.config);
    },
    // 触发软硬件配置json附件选择
    uploadHardwareConfig() {
      const input = this.$refs.hardwareConfigInput;
      if (input) {
        input.value = "";
        input.click();
      }
    },
    // 软硬件配置附件选择并上传
    async hardwareConfigFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) {
        return;
      }
      // 上传文件名 = 产品编码_版本号_上传文件原名
      const productCode = this.deviceLifeData.product ? this.deviceLifeData.product.name : "";
      const version = this.deviceLifeData.version || "";
      const newFile = new File([file], `${productCode}_${version}_${file.name}`, {
        type: file.type || "application/json",
      });
      let fd = new FormData();
      fd.append("file", newFile);
      const uploadRes = await apiUploadFile(fd);
      if (uploadRes.code != 0) {
        this.$message({ type: "error", message: uploadRes.msg || "上传失败！" });
        return;
      }
      const res = await apiFirmwareUpdateHardwareConfig({
        id: this.deviceLifeData.id,
        hardwareConfigFid: uploadRes.fid,
      });
      if (res.code == 0) {
        this.$message({ type: "success", message: "配置文件保存成功！" });
        this.getVersion();
      } else {
        this.$message({ type: "error", message: res.msg || "保存失败！" });
      }
      if (this.$refs.hardwareConfigInput) {
        this.$refs.hardwareConfigInput.value = "";
      }
    },
    async updateReleaseNotes() {
      this.dialogTitle = "修改版本日志";
      this.$refs.myDialog.dialogVisible = true;
      this.$set(this.dialogForm, "config", this.deviceLifeData.releaseNotes);
    },
    async updateCodeItem() {
      const h = this.$createElement;
      this.$msgbox({
        title: `修改物料编码`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入烧录对象的物料编码:`
          )
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        inputValue: this.dialogForm.itemCode,
        beforeClose: (action, instance, done) => {
          this.dialogForm.itemCode=instance.inputValue;
          done();
        },
      }).then(async () => {
        const res = await apiFirmwareUpdateItemCode({
          "id": this.deviceLifeData.id,
          "itemCode": this.dialogForm.itemCode
        });            
        if (res.code == 0) {
          this.$refs.myDialog.dialogVisible = false;
          this.getVersion();
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    async updatePosition() {
      
      const h = this.$createElement;
      this.$msgbox({
        title: `修改位置号`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入烧录对象在PCBA上的位置号:`
          )
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        inputValue: this.dialogForm.position,
        beforeClose: (action, instance, done) => {
          this.dialogForm.position=instance.inputValue;
          done();
        },
      }).then(async () => {
        const res = await apiFirmwareUpdatePosition({
          "id": this.deviceLifeData.id,
          "position": this.dialogForm.position
        });            
        if (res.code == 0) {
          this.$refs.myDialog.dialogVisible = false;
          this.getVersion();
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    // 保存配置信息
    async submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          if(title==="修改版本配置"){
            const res = await apiFirmwareUpdateConfig({
              "id": this.deviceLifeData.id,
              "config": this.dialogForm.config
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              // this.deviceLifeData.config = this.dialogForm.config;
              this.getVersion();
            // this.$parent.getFirmwareSearch();
            this.$message({
              message: res.msg,
              type: "success",
            });
          }
         } else if(title==="修改版本日志"){
          const res = await apiFirmwareUpdateReleaseNotes({
              "id": this.deviceLifeData.id,
              "releaseNotes": this.dialogForm.config
            });
            if (res.code == 0) {
            this.$refs.myDialog.dialogVisible = false;
            // this.deviceLifeData.config = this.dialogForm.config;
            this.getVersion();
          // this.$parent.getFirmwareSearch();
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
         }
         
        
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {
        
      };
    },
    // 删除版本
    async deleteFw(data) {
      const h = this.$createElement;
      this.$msgbox({
        title: `警告！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入版本号:【`
          ),
          h("i", { style: "color: #F56C6C;white-space:pre !important;" }, data.version),
          h("span", null, `】以确认删除，删除后无法还原！`)
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == data.version) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiFirmwareDelete({
          id : data.id
        });
        if (res.code == 0) {
          this.SNDrawerShow=false;
          this.$parent.getFirmwareSearch();
          this.$message({
            message: "删除成功，此版本已销毁！",
            type: "success"
          });
        }
      });
    },
    // 恢复已禁用的版本
    async rollbackFw(data) {
      const h = this.$createElement;
      this.$msgbox({
        title: `提示`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入版本号:【`
          ),
          h("i", { style: "color: #F56C6C;white-space:pre !important;" }, data.version),
          h("span", null, `】以确认还原，还原后需要重复发布才能量产！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == data.version) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiFirmwareRollback({
          id : data.id
        });
        if (res.code == 0) {
          this.SNDrawerShow=false;
          this.$parent.getFirmwareSearch();
          this.$message({
            message: "还原成功，量产前请重新发布版本！",
            type: "success",
          });
        }
      });
    },
    // 禁用版本
    async disableFw(data) {
      const h = this.$createElement;
      this.$msgbox({
        title: `警告！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入版本号:【`
          ),
          h("i", { style: "color: #F56C6C;white-space:pre !important;" }, data.version),
          h("span", null, `】以确认禁用，禁用的版本不能用于量产！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == data.version) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiFirmwareDisable({
          id : data.id
        });
        if (res.code == 0) {
          this.SNDrawerShow=false;
          this.$parent.getFirmwareSearch();
          this.$message({
            message: "禁用成功，该版本不能在用于量产！",
            type: "success",
          });
        }
      });
    },
    // 发布版本
    async releaseFw(data) {
      const h = this.$createElement;
      this.$msgbox({
        title: `提示`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入版本号:【`
          ),
          h("i", { style: "color: #F56C6C;white-space:pre !important;" }, data.version),
          h("span", null, `】以确认发布当前版本`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == data.version) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiFirmwareRelease({
          id : data.id
        });
        if (res.code == 0) {
          this.SNDrawerShow=false;
          this.$parent.getFirmwareSearch();
          this.$message({
            message: "发布成功，已经可以量产了！",
            type: "success",
          });
        }
      });
    },
    // 下载文件
    async downloadFile(fid, fileName, secretKey) {
      let url = apiDownloadFile(fid, secretKey);
      let a = document.createElement("a");
      a.href = url;
      if (fileName) {
        a.download = fileName;
      }
      a.style.display = "none";
      a.target = "_blank"
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 版本配置
    async getVersion() {
      const res = await apiFirmwareDetail({
        id: this.drawerOption.versionId,
      });
      // console.log(res);
      if (res.code == 0) {
        this.deviceLifeData = res.data;
        this.SNDrawerShow = true;
        this.$nextTick(() => {
          // document.querySelector(".myDrawer .el-drawer__body").scrollTop = 9999;
        });
      }
    },
    // 产品生命线
    async getDeviceLife() {
      const res = await apiDeviceLife({
        id: this.drawerOption.currentSNId,
      });
      // console.log(res);
      if (res.code == 0) {
        this.deviceLifeData = res.data;
        this.SNDrawerShow = true;
        this.$nextTick(() => {
          document.querySelector(".myDrawer .el-drawer__body").scrollTop = 9999;
        });
      }
    },
    // PCBA SN 生命周期
    async getPcbaSnLife() {
      const res = await apiPcbaSnLife({
        id: this.drawerOption.currentSNId,
      });
      if (res.code == 0) {
        this.deviceLifeData = res.data;
        this.SNDrawerShow = true;
        this.$nextTick(() => {
          document.querySelector(".myDrawer .el-drawer__body").scrollTop = 9999;
        });
      }
    },
    // 产品生命线
    async getPcbaLife() {
      this.exportXls = false;
      const res = await apiPcbaLife({
        id: this.drawerOption.currentSNId,
      });
      if (res.code == 0) {
        this.deviceLifeData = res.data;
        this.SNDrawerShow = true;
        this.$nextTick(() => {
          document.querySelector(".myDrawer .el-drawer__body").scrollTop = 9999;
        });
      }
    },
    downLifeBtn(e, text) {
      e.target.blur();
      if (this.deviceLifeData.lifeLine.length != 0) {
        this.$confirm(`确定导出该SN的生命周期吗？`, `导出${text}`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          if (text == "图片") {
            this.$canvasDownload(
              ".myDrawer .el-drawer__body .el-timeline",
              this.drawerOption.currentSNName
            );
          } else {
            const res = await apiDeviceLife({
              id: this.drawerOption.currentSNId,
              export: true,
            });
            if (res.code == 0) {
              this.$downloadFile(res.fid, res.fileName, res.secretKey);
            }
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "该SN无数据可供导出！",
        });
      }
    },
    workStationBtn(activity) {
      this.$processLogDetail(activity);
    },
    closedMyDrawer() {
      this.deviceLifeData = {
        lifeLine: [],
        workStationVo: {},
      };
    },
  },
};
</script>

<style lang="less" scoped>
.myDrawer {
  /deep/.el-drawer {
    width: 370px !important;
    .el-drawer__header {
      padding: 15px;
      margin-bottom: 0;
      align-items: flex-start;
      .name {
        color: #303133;
        font-weight: bold;
        word-break: break-all;
      }
      .ifFocus {
        height: 0;
        border: 0;
        padding: 0;
      }
      .myIcon {
        width: 20px;
        height: 20px;
        // font-size: 20px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
    .el-drawer__body {
      overflow: auto;
      .el-timeline {
        padding: 10px 25px 0;
        .el-timeline-item__dot {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          color: #fff;
          background-color: #ccc;
          top: -2px;
          left: -5px;
        }
        .allowSkip {
          display: block;
        }
        // 执行成功的结果文本跟随主题色（失败 .danger 为全局状态红，不变）
        .success {
          color: var(--themeColor);
        }
        p {
          display: flex;
          margin-bottom: 10px;
          span:nth-child(1) {
            flex: 0 0 50px;
          }
          span:nth-child(2) {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .noData {
        color: #aaa;
        text-align: center;
      }
      .versonBox {
        padding: 10px 10px 10px 15px;
        color: #606266;
        p {
          display: flex;
          margin-bottom: 10px;
          span:nth-child(1) {
            flex: 0 0 80px;
          }
          span:nth-child(2) {
            flex: 1;
            // word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    textarea {
      padding: 2px, 5px !important;
    }
    textarea:focus {
      border: 1px solid #DCDFE6;
    }
  }
}
</style>

<!-- myDrawer 护眼深色模式（非 scoped，因为 el-drawer 挂在 body 上） -->
<style lang="less">
.theme-dark .myDrawer {
  .el-drawer {
    background-color: var(--bgPanel) !important;

    .el-drawer__header {
      border-bottom-color: var(--borderLight) !important;

      .name {
        color: var(--textPrimary) !important;
      }
    }

    .el-drawer__body {
      .el-timeline-item__timestamp {
        color: var(--textSecondary) !important;
      }

      .el-timeline-item__dot {
        color: var(--bgPanel) !important;
        background-color: var(--borderBase) !important;
      }

      .el-timeline-item__tail {
        border-left-color: var(--borderLight) !important;
      }

      .el-timeline-item__content,
      .el-timeline-item p span {
        color: var(--textRegular) !important;
      }

      .noData {
        color: var(--textSecondary) !important;
      }

      .versonBox {
        color: var(--textRegular) !important;
      }

      textarea {
        background-color: var(--bgInput) !important;
        color: var(--textRegular) !important;
        border-color: var(--borderBase) !important;

        &:focus {
          border-color: var(--themeColor) !important;
        }
      }
    }
  }
}
</style>